import { render, staticRenderFns } from "./RegisterContainer.vue?vue&type=template&id=6bbf6e63&scoped=true"
import script from "./RegisterContainer.vue?vue&type=script&lang=js"
export * from "./RegisterContainer.vue?vue&type=script&lang=js"
import style0 from "./RegisterContainer.vue?vue&type=style&index=0&id=6bbf6e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf6e63",
  null
  
)

export default component.exports